import React, { useEffect, useState } from "react";
import AdminLayout from "./AdminLayout";

const AdminEvent = () => {
  const [form, setForm] = useState({
    narration: "",
    image: null,
  });

  const [preview, setPreview] = useState(null);
  const [events, setEvents] = useState([]);
  const [editId, setEditId] = useState(null);

  // FETCH
  const fetchEvents = () => {
    fetch("https://njinternational.ilakshyaerp.in/api/events")
      .then((res) => res.json())
      .then((data) => setEvents(Array.isArray(data) ? data : []))
      .catch((err) => console.log("Fetch error:", err));
  };

  useEffect(() => {
    fetchEvents();
  }, []);

  // SUBMIT
  const handleSubmit = () => {
    if (!form.narration) {
      alert("Please enter narration ❌");
      return;
    }

    const formData = new FormData();
    formData.append("narration", form.narration);

    if (form.image) {
      formData.append("image", form.image);
    }

    const url = editId
      ? `https://njinternational.ilakshyaerp.in/api/events/${editId}`
      : "https://njinternational.ilakshyaerp.in/api/events/add";

    const method = editId ? "PUT" : "POST";

    fetch(url, {
      method,
      body: formData,
    })
      .then(async (res) => {
        const data = await res.json();

        if (!res.ok) {
          throw new Error(data.message);
        }

        return data;
      })
      .then((data) => {
        alert(data.message || "Success ✅");

        setForm({ narration: "", image: null });
        setPreview(null);
        setEditId(null);
        fetchEvents();
      })
      .catch((err) => {
        alert(err.message || "Something went wrong ❌");
      });
  };

  // EDIT
  const handleEdit = (event) => {
    setForm({
      narration: event.narration,
      image: null,
    });

    setPreview(
      `https://njinternational.ilakshyaerp.in/uploads/events/${event.image}`
    );

    setEditId(event.id);
  };

  // DELETE
  const handleDelete = (id) => {
    fetch(`https://njinternational.ilakshyaerp.in/api/events/${id}`, {
      method: "DELETE",
    })
      .then((res) => res.json())
      .then(() => fetchEvents())
      .catch(() => alert("Delete failed ❌"));
  };

  return (
    <AdminLayout>
      <div className="notice-page">

        {/* FORM */}
        <div className="notice-card">
          <h2>{editId ? "Edit Event" : "Add Event"}</h2>

          <textarea
            placeholder="Enter narration"
            value={form.narration}
            onChange={(e) =>
              setForm({ ...form, narration: e.target.value })
            }
          />

          <input
            type="file"
            accept=".jpg,.jpeg,.png"
            onChange={(e) => {
              const file = e.target.files[0];

              if (!file) return;

              // ✅ FILE SIZE CHECK (10MB)
              if (file.size > 10 * 1024 * 1024) {
                alert("Image must be less than 10MB ❌");
                return;
              }

              setForm({ ...form, image: file });
              setPreview(URL.createObjectURL(file));
            }}
          />

          {/* IMAGE PREVIEW */}
          {preview && (
            <img
              src={preview}
              alt="preview"
              style={{
                width: "100%",
                marginTop: "10px",
                borderRadius: "8px",
              }}
            />
          )}

          <button onClick={handleSubmit}>
            {editId ? "Update Event" : "Add Event"}
          </button>
        </div>

        {/* TABLE */}
        <div className="notice-table">
          <h2>All Events</h2>

          <table>
            <thead>
              <tr>
                <th>Image</th>
                <th>Narration</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {events.length === 0 ? (
                <tr>
                  <td colSpan="3">No events found</td>
                </tr>
              ) : (
                events.map((e) => (
                  <tr key={e.id}>
                    <td>
                      <img
                        src={`https://njinternational.ilakshyaerp.in/uploads/events/${e.image}`}
                        width="80"
                        alt="event"
                      />
                    </td>

                    <td>{e.narration}</td>

                    <td>
                      <button
                        className="edit-btn"
                        onClick={() => handleEdit(e)}
                      >
                        Edit
                      </button>

                      <button
                        className="delete-btn"
                        onClick={() => handleDelete(e.id)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

      </div>
    </AdminLayout>
  );
};

export default AdminEvent;